import { namespacedClassnames } from '../../common';
import * as React from 'react';
export var Icon = function (props) {
    var html = { __html: props.icon };
    var className = namespacedClassnames('icon', 'svg-icon', props.className, { 'has-color-override': !!props.color });
    var style = props.color && { '--var-color': props.color };
    return (React.createElement("span", { className: className, dangerouslySetInnerHTML: html, style: style, "aria-hidden": props.ariaHidden }));
};
//# sourceMappingURL=icon.js.map